import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import BudgetToActualContainer from '../../containers/budgettoactual/BudgetToActualContainer';

const BudgetToActualPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="경영정보/예산vs실적 현황" icon="statistics" />
      <BudgetToActualContainer />
    </>
  );
};

export default BudgetToActualPage;
